import * as e from "react";
import { forwardRef as o } from "react";
const l = o(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("rect", { fill: "currentColor", height: 8, width: 8, x: 8, y: 8 })
  );
});
export {
  l as Finished
};
